import React, { useContext, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { types } from '../../Types/types'
import { useMutation } from '@apollo/client'
import { AUTH_USER, DECRYPT_TOKEN } from '../../graphql/Auth/auth'
import { GET_ALL_USER_PERMISSIONS } from '../../graphql/Catalog/Users/user'
import { AuthContext } from '../../Auth/AuthContext'
import Logo from './../../Assets/Images/logo-02.png'
import Swal from 'sweetalert2'
import MigrantsHeader from '../DashboardMigrants/components/MigrantsHeader'
import MigrantsFooter from '../DashboardMigrants/components/MigrantsFooter'

export const Login = () => {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    },
  })

  const location = useLocation()
  const messageFromState = location.state?.reason
  const queryParams = new URLSearchParams(location.search)
  const messageFromQuery = queryParams.get('reason')
  const isExpired =
    messageFromState === 'expired' || messageFromQuery === 'expired'
  const message = isExpired
    ? 'Tu sesión ha expirado, por favor inicia sesión de nuevo.'
    : messageFromState || messageFromQuery

  const { dispatch } = useContext(AuthContext)
  const [form, setForm] = useState({
    email: '',
    password: '',
  })
  const [loading, setLoading] = useState(false)

  const [authUser] = useMutation(AUTH_USER)
  const [decryptToken] = useMutation(DECRYPT_TOKEN)
  const [getAllUserPermissions] = useMutation(GET_ALL_USER_PERMISSIONS, {
    fetchPolicy: 'no-cache',
  })

  const handleLogin = async (e) => {
    e.preventDefault()
    setLoading(true)
    try {
      const { data: dataToken } = await authUser({
        variables: {
          input: {
            email: form.email.toLowerCase().trim(),
            password: String(form.password).trim(),
          },
        },
      })
      const token = dataToken.authUser.token
      localStorage.setItem('token', token)
      const { data: tokenData } = await decryptToken({
        variables: {
          token,
        },
      })
      const decoded = tokenData.decryptToken
      const { data: userPermissionsData } = await getAllUserPermissions({
        variables: {
          userID: decoded.id,
        },
      })
      const userPermissions = userPermissionsData.getAllUserPermissions

      let newUserPermissions = []
      userPermissions?.map((module) => {
        if (module?.ReportsPowerBIModelOfUserModules.length > 0) {
          module.ReportsPowerBIModelOfUserModules.forEach((report) => {
            let hasSubmodule =
              report?.sub_module_id && report?.sub_module_id !== 0
            let submodule_info = {
              front_label: report?.front_label,
              icon: report?.icon ? report.icon : 'circle',
              name: hasSubmodule
                ? `${module?.module_info.name}Submodule`
                : module?.module_info.name,
              relative_link: hasSubmodule
                ? report?.pathname_module
                : `/reportPowerBi${report?.pathname_module}`,
            }

            let module_info = hasSubmodule
              ? {
                  ...module?.module_info,
                  name: module?.module_info.name + 'Submodule',
                }
              : submodule_info
            newUserPermissions.push({
              access_delete: module?.access_delete,
              access_edit: module?.access_edit,
              access_export: module?.access_export,
              access_import: module?.access_import,
              access_read: module?.access_read,
              access_retrieve: module?.access_retrieve,
              id: module?.id,
              id_module: module?.id_module,
              id_submodule: hasSubmodule ? report.sub_module_id : null,
              submodule_info: hasSubmodule ? submodule_info : null,
              module_info,
            })
          })
        } else newUserPermissions.push(module)
      })

      setLoading(false)
      dispatch({
        type: types.login,
        payload: {
          logged: true,
          type_user: decoded.type_user,
          idUser: decoded.id,
          role: decoded.role,
          email: decoded.email,
          userPermissions: newUserPermissions,
          avatar: decoded.avatar,
          name: decoded.name,
          first_name: decoded?.first_name,
          last_name: decoded?.last_name,
          phone: decoded.phone,
          jurisdiction_id: decoded.jurisdiction_id,
          sub_jurisdiction_id: decoded.sub_jurisdiction_id,
          provider_id: decoded?.provider_id,
        },
      })
    } catch (error) {
      setLoading(false)
      return Toast.fire({
        icon: 'error',
        title: error.message,
      })
    }
  }

  const handleSeePassword = () => {
    const iconPass = document.getElementById('iconPass')
    var pw = document.getElementById('pass')
    if (pw.type === 'password') pw.type = 'text'
    else pw.type = 'password'
    iconPass.classList.toggle('fa-eye-slash')
  }

  return (
    <div className="login-container row">
      <div className="col-12">
        <MigrantsHeader showContact={false} />
      </div>
      <div className="login-content col-12">
        {/* <Link to="/" className="h1 d-flex justify-content-center mb-5 mt-5">
          <img src={Logo} className="img-logo-full" alt="logo" />
        </Link> */}
        <h5 className='title-migrates'>Bienvenido</h5>
        <span className='text-migrates'>Inicia sesión para continuar</span>
        {message && <div className="alert alert-warning">{message}</div>}
        <div className="full-box mt-3" id="boxLogin">
          <form
            onSubmit={handleLogin}
            method="post"
            className="row"
            autoComplete="new-password"
          >
            <label htmlFor="user" className='text-migrates'>Email</label>
            <div className="input-icons-login col-12 iconInside">
              <i className="fas fa-envelope"></i>
              <input
                id="user"
                type="text"
                className="form-control"
                placeholder="Nombre de usuario o correo electrónico"
                onChange={(e) => setForm({ ...form, email: e.target.value })}
              />
            </div>
            <label htmlFor="pass" className='text-migrates'>Contraseña</label>
            <div className="input-icons-login col-12 iconInside">
              <i className="fas fa-key"></i>
              <input
                id="pass"
                type="password"
                className="form-control"
                placeholder="Contraseña"
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                autoComplete="off"
              />
              <i
                id="iconPass"
                className="fa fa-eye fa-eye-slash"
                onClick={handleSeePassword}
              ></i>
            </div>
            <div className="actions-login col-12 text-center">
              {/* <div className="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="remember"
                />
                <label className="custom-control-label" htmlFor="remember">
                  Recordarme
                </label>
              </div> */}
              {/* <div className="row d-flex flex-column">
                <Link to="/recuperar-contraseña">Olvidé mi contraseña</Link>
                <Link to="/loginRegister" className="register-link">
                  ¿No tienes cuenta? Registrate
                </Link>
              </div> */}
            </div>

            <div className="login-btn col-12">
              {loading ? (
                <button
                  className="btn btn-migrates btn-login"
                  type="button"
                  disabled
                >
                  <span
                    className="spinner-grow spinner-grow-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span className="sr-only">Procesando...</span>
                </button>
              ) : (
                <>
                  <Link to="/recuperar-contraseña" className='recovery-password-button'>RECUPERAR CONTRASEÑA</Link>
                  <button type="submit" className="btn btn-migrates">
                    INICIAR SESIÓN
                  </button>
                  <Link to="/loginRegister" className="btn btn-migrates-white mt-2">
                    REGISTRARSE
                  </Link>
                </>
              )}
            </div>
          </form>
        </div>
      </div>
      <div className="col-12">
        <MigrantsFooter showContact={false} showChatbot={false} />
      </div>
    </div>
  )
}

export default Login
